var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-feedback" },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.translations.tooltip_label_like,
            placement: "top"
          }
        },
        [
          _c("CompassIconButton", {
            attrs: { icon: _vm.likeIcon, size: "small" },
            on: { click: _vm.handleLike }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.translations.tooltip_label_dislike,
            placement: "top"
          }
        },
        [
          _c("CompassIconButton", {
            ref: "dislikeIconRef",
            attrs: { icon: _vm.dislikeIcon, size: "small" },
            on: { click: _vm.handleDislike }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            triggerRef: "dislikeIconRef",
            isVisible: _vm.showFeedbackPopover,
            placement: _vm.placement,
            customClass: "ai-feedback__popover"
          },
          on: {
            close: function($event) {
              _vm.showFeedbackPopover = false
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ai-feedback__popover-header" },
            [
              _c(
                "div",
                { staticClass: "ai-feedback__popover-tag" },
                _vm._l(_vm.tags, function(tag, index) {
                  return _c("CompassTagInteractive", {
                    key: index,
                    attrs: {
                      color: "light-gray",
                      variant: "selectable",
                      modelValue: tag.label,
                      isSelected: tag.selected,
                      valueLabel: tag.label
                    },
                    on: {
                      change: function($event) {
                        return _vm.selectTagFeedback(index)
                      }
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("CompassIconButton", {
                attrs: { icon: "close" },
                on: { click: _vm.handleCloseIconPopover }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("CompassInput", {
            ref: "feedbackInput",
            attrs: {
              type: "textarea",
              placeholder: _vm.translations.textarea_placeholder
            },
            on: { keypress: _vm.onKeypressMessage },
            model: {
              value: _vm.messageFeedback,
              callback: function($$v) {
                _vm.messageFeedback = $$v
              },
              expression: "messageFeedback"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ai-feedback__popover-button" },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.translations.sendButton,
                  type: "secondary",
                  disabled: _vm.disabledFeedbackButton
                },
                on: { click: _vm.handleValidateFeedback }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }